import Vue from 'vue';
import Router from 'vue-router';
import Tab1 from '../src/components/tabulardata.vue'
// import tabulardata2 from '../src/components/tabularData2.vue'
import DatatablePage from '../src/components/tabularData2.vue'
import Certificates from '../src/components/certificates.vue'
import ResetPassword from '../src/components/resetPassword.vue'
import HelpDesk from '../src/components/helpDesk.vue'
import Login from '../src/components/login.vue'
import AddUser from '../src/components/addUser.vue'
import DelUser from '../src/components/delUser.vue'
import ProCourseUser from '../src/components/proCourseUser.vue'
import HackerxProUser from '../src/components/hackerxProUser.vue'
import PythonxProUser from '../src/components/pythonxProUser.vue'
import Offer from '../src/components/offer.vue'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/promocode',
      name: 'Tab1',
      component: Tab1,
    },
    {
      path: '/proUser',
      name: 'datatablePage',
      component: DatatablePage,
    },
    {
      path: '/certificates',
      name: 'Certificates',
      component: Certificates,
    },
    {
      path: '/resetPassword',
      name: 'ResetPassword',
      component: ResetPassword,
    },
    {
      path: '/helpDesk',
      name: 'HelpDesk',
      component: HelpDesk,
    },
    {
      path: '/addUser',
      name: 'AddUser',
      component: AddUser,
    },
    {
      path: '/delUser',
      name: 'DelUser',
      component: DelUser,
    },
    {
      path: '/proCourseUser',
      name: 'ProCourseUser',
      component: ProCourseUser,
    },
    {
      path: '/hackerxProUser',
      name: 'HackerxProUser',
      component: HackerxProUser,
    },
    {
      path: '/pythonxProUser',
      name: 'PythonxProUser',
      component: PythonxProUser,
    },
    {
      path: '/offer',
      name: 'Offer',
      component: Offer,
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (!localStorage.getItem('storedData') && to.path !== '/') {
    next('/')
  }
  if (localStorage.getItem('storedData') && to.path === '/' && from.path === '/') {
    next('/promocode')
  }
  next()
})

export default router